import React from "react";
import { NavigationDots, SocialMedia } from "../components";

const AppWrapp = (Component, idName, classNames) =>
  function HOC() {
    // Create a new Date object
    let currentDate = new Date();
    // Get the current year
    let currentYear = currentDate.getFullYear();
    return (
      <div id={idName} className={`app__container ${classNames}`}>
        <SocialMedia />
        <div className="app__wrapper app__flex">
          <Component />

          <div className="copyright">
            <p className="p-text">@{currentYear} DEJAN</p>
            <p className="p-text">All Rights Reserved</p>
          </div>
        </div>

        <NavigationDots active={idName} />
      </div>
    );
  };

export default AppWrapp;
